// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3uiVs","modalForm":"UpgradeEpcsModal_modalForm__vL5UZ","modalFooter":"UpgradeEpcsModal_modalFooter__P9ngL"};